import Card from '../Card'

export default class Potion extends Card {
  name = 'Potion'

  constructor(public value: number) {
    super()
  }

  pick(picker = this.board!.hero.card) {
    if (!super.pick(picker)) return false

    const hero = this.board!.hero
    const movePickerHere = () => picker.moveTo(this.location!)

    picker.heal(this.value)
    movePickerHere()
    this.drawCards()

    return true
  }

  clone() {
    return new Potion(this.value)
  }
}
